export default __webpack_public_path__ + "static/cooling_towers_b.664c0e507d18b529b34c2e9a3af63d36.svg";